import React from "react";
import { useHistory } from "react-router-dom";

import styles from "./styles.module.scss";

export interface IProps {
  title: string;
  serviceList: string[];
  uri: string;
}

const ServiceView: React.FC<IProps> = (props) => {
  const history = useHistory();

  const goToGallery = () => {
    history.push("/gallery");
  };

  return (
    <div className={styles.container}>
      <img className={styles["background-image"]} src={props.uri} alt="" />
      <div className={styles.content}>
        <div>
          <h1>{props.title}</h1>
          <ul>
            {props.serviceList.map((name, index) => {
              return <li key={index}>{name}</li>;
            })}
          </ul>
        </div>
        <button onClick={goToGallery}>View Gallery</button>
      </div>
    </div>
  );
};

export default ServiceView;
